import { createIcon } from '@chakra-ui/icons';

export const Heart = createIcon({
  displayName: 'Heart',
  viewBox: '0 0 15 14',
  path: [
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1494 0.762665C9.1638 0.762665 8.29086 1.17565 7.6507 1.82141C7.41895 2.05519 7.01311 2.05519 6.78136 1.82141C6.14119 1.17565 5.26826 0.762665 4.2827 0.762665C2.3467 0.762665 0.762695 2.34666 0.762695 4.28266C0.762695 7.35051 5.66462 11.7552 6.92394 12.8362C7.09344 12.9817 7.33861 12.9817 7.50811 12.8362C8.76744 11.7552 13.6694 7.35051 13.6694 4.28266C13.6694 2.34666 12.0854 0.762665 10.1494 0.762665Z"
        stroke="currentColor"
        strokeWidth="1.52533"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
